export default __webpack_public_path__ + "static/media/Shell5Open.3480caf5.png";